"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestGroupRelatedAction = void 0;
/**
 * A group of related requests that can be used to capture intended activities that have inter-dependencies such as \"give this medication after that one\".
 */
var RequestGroupRelatedAction = /** @class */ (function () {
    function RequestGroupRelatedAction() {
    }
    return RequestGroupRelatedAction;
}());
exports.RequestGroupRelatedAction = RequestGroupRelatedAction;
